<template>
    <div class="page">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/profile.png" />
        </header>

        <div class="scroller2" :class="{ pending: isPending }">
            <header>
                <h2>{{ isPending ? "Pending" : "Invite new" }} Player</h2>
                <ul class="links">
                    <li>
                        <a
                            class="cancel"
                            @click.prevent="goToLocation({ name: 'proPlayers' })"
                            href="#"
                        >
                            <x-icon class="icon" />
                        </a>
                    </li>
                </ul>
            </header>

            <form class="form2" @submit.prevent="addPendingPlayer" id="invitePlay">
                <div class="formGroup" :class="{ invalid: form.errors.has('first_name') }">
                    <label>First name</label>
                    <input
                        data-cy="first_name"
                        autocomplete="nope"
                        type="text"
                        v-model="form.first_name"
                    />
                    <!--<has-error data-cy="first_name_error" :form="form" field="first_name"></has-error>-->
                </div>
                <div class="formGroup" :class="{ invalid: form.errors.has('last_name') }">
                    <label>Last name</label>
                    <input
                        data-cy="last_name"
                        autocomplete="nope"
                        type="text"
                        v-model="form.last_name"
                    />
                    <!--<has-error  data-cy="last_name_error" :form="form" field="last_name"></has-error>-->
                </div>
                <div class="formGroup" :class="{ invalid: form.errors.has('email') }">
                    <label>Email address</label>
                    <input data-cy="email" autocomplete="nope" type="email" v-model="form.email" />
                </div>
                <has-error data-cy="email_error" :form="form" field="email"></has-error>

                <div class="formGroup" :class="{ invalid: form.errors.has('phone') }">
                    <label>Telephone number</label>
                    <phone-number-field v-model="form.phone"></phone-number-field>
                </div>
                <has-error data-cy="phone_error" :form="form" field="phone"></has-error>

                <button
                    v-if="isPending"
                    class="button half"
                    :disabled="sendingBusy"
                    @click.prevent="resend"
                >
                    Resend
                </button>
                <button
                    @click.prevent="removePendingPlayer"
                    v-if="isPending"
                    class="button half red"
                >
                    Cancel
                </button>

                <button
                    data-cy="Invite player"
                    v-if="!isPending"
                    class="button"
                    :disabled="form.busy"
                    type="submit"
                    name="button"
                >
                    {{ form.busy ? "Please wait..." : "Invite player" }}
                </button>
            </form>
        </div>
    </div>
</template>

<script>
import FadeImage from "@/components/App/fade-image";
import { XIcon } from "vue-feather-icons";
import { Form, HasError } from "vform";
export default {
    name: "invite",
    components: { FadeImage, XIcon, HasError },
    computed: {
        user() {
            return this.$store.state.user;
        },
        isPending() {
            return this.$route.name == "proPlayerPending";
        },
    },
    created() {
        if (this.isPending) {
            this.getPendingPlayer();
            this.$store.dispatch("getPendingPlayers");
        }
    },
    data() {
        return {
            sendingBusy: false,
            form: new Form({
                first_name: "",
                last_name: "",
                email: "",
                phone: "",
            }),
        };
    },
    methods: {
        goToLocation($url) {
            if (this.$route.query.from == "home") {
                this.$router.push({ name: "proHome" });
            } else {
                this.$router.push($url);
            }
        },
        getPendingPlayer() {
            this.form.get("/pending_player/" + this.$route.params.id).then((response) => {
                this.form.fill(response.data);
            });
        },
        addPendingPlayer() {
            this.form.post("/pending_player").then((response) => {
                this.$notify({
                    duration: 3000,
                    text: "Your player has been added. An email has been sent to them explaining how to sign up.",
                });
                this.$store.dispatch("addToPendingPlayers", response.data);
                this.$router.push({ name: "proPlayers" });
            });
        },
        resend() {
            this.sendingBusy = true;
            this.form
                .post("/pending_player/resend/" + this.$route.params.id)
                .then(() => {
                    this.$notify("An email has been resent to " + this.form.first_name);
                    this.sendingBusy = false;
                })
                .catch(() => {
                    this.sendingBusy = false;
                });
        },
        removePendingPlayer() {
            this.$confirm("Are you sure you want to remove this pending player?", () => {
                this.form.delete("/pending_player/" + this.$route.params.id).then(() => {
                    this.$notify({
                        duration: 3000,
                        text: "Your player has been deleted.",
                    });
                    this.$store.dispatch("removePendingPlayer", this.$route.params.id);
                    this.$router.push({ name: "proPlayers" });
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.scroller2.pending {
    background: #baf8e1;
}
#invitePlay {
    label {
        color: #939a93;
        margin-top: 20px;
        display: block;
    }
}
</style>
